import classes from './CustomizedTextArea.module.scss';
import React from 'react';
interface ICustomizedTextAreaProps {
    [rest: string]: any;
}
export const CustomizedTextArea = React.forwardRef<any, ICustomizedTextAreaProps>(({ ...rest }, ref) => {
    return <textarea className={classes.customizedTextAreaContainer} {...rest} ref={ref} />;
});
